import React, { useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";


import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";

import ser1 from "../image/ser1.png";
import liasoningImg from "../image/service-image/liasoning-image.png";
import serTurnkey from "../image/ser-turnkey.png";
import ser4 from "../image/ser4.png";
import pmcImg from "../image/bungalow-bg.png2.png";

const services = [
  {
    id: "architecture",
    title: ["Architecture Design", "Services"],
    desc: "Personalized home designs that are beautiful, functional, and practical.",
    path: "/architecture",
    img: ser1,
    btn: "Start My Custom Design",
  },

  {
    id: "liaisoning",
    title: ["Liaisoning - Design", "Approvals"],
    desc: "We handle all approvals from PMC, PCMC & PMRDA.",
    path: "/liaisoning",
    img: liasoningImg,
    btn: "Get My Plans Approved",
  },

  {
    id: "construction",
    title: ["Complete Turnkey", "Construction"],
    desc: "Quality construction with full execution & supervision.",
    path: "/construction",
    img: serTurnkey,
    btn: "Let's Build My Home",
  },

  {
    id: "interior",
    title: ["Interior Design", "Services"],
    desc: "We design interiors with comfort, aesthetics, and creativity.",
    path: "/interior",
    img: ser4,
    btn: "Style My Interiors",
  },

  {
    id: "pmc",
    title: ["PMC (Project Management Consultancy)"],
    desc: "End-to-end construction support for smooth project execution and coordination.",
    path: "/pmc",
    img: pmcImg,
    btn: "Manage My Project",
  },
];

export default function OtherServicesSlider() {

  const navigate = useNavigate();
  const location = useLocation();

  const swiperRef = useRef(null);

  const current = location.pathname
    .replace(/^\/+|\/+$/g, "")
    .toLowerCase();

  const filteredServices = services.filter(
    (s) => s.id !== current
  );

  return (

    <section className="dw-services-section">

      <div className="container-fluid">

        <div className="dw-services-heading text-center other-services-heading">

          <h2>Continue Your Home Journey</h2>

          <p>
            Explore other services to complete your home seamlessly
          </p>

        </div>

        <Swiper

          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}

          spaceBetween={20}

          slidesPerView={1.2}

          breakpoints={{
            768: {
              slidesPerView: 2,
            },

            1024: {
              slidesPerView: 3,
            },
          }}
        >

          {filteredServices.map((service) => (

            <SwiperSlide key={service.id}>

              <div
                className="dw-service-card"
                onClick={() => navigate(service.path)}
                style={{ cursor: "pointer" }}
              >

                <div className="dw-service-img-wrapper">

                  <img
                    src={service.img}
                    alt={service.title.join(" ")}
                    className="dw-service-img"
                  />

                </div>

                <div className="dw-service-content">

                  <h5>

                    {service.title.map((line, i) => (

                      <span key={i}>
                        {line}
                        <br />
                      </span>

                    ))}

                  </h5>

                  <p>{service.desc}</p>

                  <div className="dw-service-link mt-2 mb-2">

                    {service.btn}

                    <span className="arrow-service">

                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="16"
                        viewBox="0 0 40 16"
                        fill="none"
                        stroke="#ffffff"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >

                        <line x1="2" y1="8" x2="32" y2="8" />

                        <polyline points="26 3 32 8 26 13" />

                      </svg>

                    </span>

                  </div>

                </div>

              </div>

            </SwiperSlide>

          ))}

        </Swiper>

        {/* NAV BUTTONS */}

        <div className="dw-service-nav mt-5">

          <button
            className="dw-service-btn"
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <span className="arrow">←</span>
          </button>

          <button
            className="dw-service-btn"
            onClick={() => swiperRef.current?.slideNext()}
          >
            <span className="arrow">→</span>
          </button>

        </div>

      </div>

    </section>
  );
}
